export enum ApiStatusCodes {
  Unauthorized = 401,
  Forbidden = 403,
}

export enum ApiMessages {
  RequiresVerification = 'requires_verification',
  Locked = 'account_locked',
}
